import React from 'react'
import { CarouselCard, CarouselAction } from '../../types'
import style from './actions.module.scss'
import { Switch, Select } from '../../../../components'

type Props = {
	card: CarouselCard
	index: number
	updateCard: (key: keyof CarouselCard, value: any, index: number) => void
	mode: "view" | "edit" | "create"
	error: Record<string, string> | undefined
	clearError: (index: number, name: "actions" | "cards", key: string) => void
}

export function Actions(props: Props) {
	const { updateCard, index, card, mode } = props
	const { actions } = card
	const isPrimary = "primary" in actions
	const isSecondary = "secondary" in actions

	const styles = {
		primary: {
			'--checked-bg': isPrimary ? '#F1722E' : '',
		},
		secondary: {
			'--checked-bg': isSecondary ? '#F1722E' : '',
		},
	}

	return (
		<div className={style.actions}>
			<p>Actions</p>
			<div className={style.main}>
				<div className={style.frame}>
					<div className={style.header} style={styles.primary as any}>
						<p>Primary Button</p>
						<Switch disabled={mode === "view"} checked={isPrimary} onSwitch={value => {
							if (value) {
								updateCard("actions", {
									...card.actions,
									primary: {
										label: "",
										type: "messageBack",
									}
								}, index)
							} else {
								const updatedActions = { ...card.actions }
								delete updatedActions.primary
								updateCard("actions", updatedActions, index)
							}
						}} />
					</div>
					{isPrimary && <Action action={actions.primary} actionKey="primary" {...props}/>}
				</div>
				<div className={style.frame}>
					<div className={style.header} style={styles.secondary as any}>
						<p>Secondary Button</p>
						<Switch disabled={mode === "view"} checked={"secondary" in actions} onSwitch={value => {
							if (value) {
								updateCard("actions", {
									...card.actions,
									secondary: {
										label: "",
										value: "",
										type: "openUrl",
									}
								}, index)
							} else {
								const updatedActions = { ...card.actions }
								delete updatedActions.secondary
								updateCard("actions", updatedActions, index)
							}
						}} />
					</div>
					<div className={style.content}>
						{isSecondary && <Action action={actions.secondary} actionKey="secondary" {...props}/>}
					</div>
				</div>
			</div>
		</div>
	)
}

type ActionProps = Props & {
	action: CarouselAction
	actionKey: "primary" | "secondary"
}

function Action(props: ActionProps) {
	const { action, updateCard, actionKey, index, card, mode, error = {}, clearError } = props
	return (
		<div className={style.content}>
			<div className={style.inputWrapper}>
				<label>Label</label>
				<input disabled={mode === "view"} autoFocus placeholder="Enter label" value={action.label} onChange={(e) => {
					clearError(index, "actions", actionKey === "primary" ? "primaryLabel" : "secondaryLabel")
					const label = e.currentTarget.value
					updateCard("actions", {
						...card.actions,
						[actionKey]: {
							...card.actions[actionKey],
							label,
						}
					}, index)
				}} />
				<span className={style.error}>{actionKey === "primary" ? error.primaryLabel : error.secondaryLabel}</span>
			</div>
			<div className={style.inputWrapper}>
				<label>Type</label>
				<Select options={options} value={action.type} placeholder="Select" onSelect={value => {
					const existingAction = {...card.actions[actionKey]}
					if(value === 'messageBack') {
						delete (existingAction as any).value
					}
					updateCard("actions", {
						...card.actions,
						[actionKey]: {
							...existingAction,
							type: value,
						}
					}, index)
				}} />
			</div>
			{action.type === 'openUrl' && (
				<div className={style.inputWrapper}>
					<label>URL</label>
					<input disabled={mode === "view"} value={action.value} placeholder="Enter url" onChange={(e) => {
						clearError(index, "actions", actionKey === "primary" ? "primaryURL" : "secondaryURL")
						const value = e.currentTarget.value
						updateCard("actions", {
							...card.actions,
							[actionKey]: {
								...card.actions[actionKey],
								value,
							}
						}, index)
					}}/>
					<span className={style.error}>{actionKey === "primary" ? error.primaryURL : error.secondaryURL}</span>
				</div>
			)}
		</div>
	)
}

const options = [
	{ label: "Message Back", value: "messageBack" },
	{ label: "Open URL", value: "openUrl" },
]
